import { render, staticRenderFns } from "./serialPack2.vue?vue&type=template&id=49715010&scoped=true&"
import script from "./serialPack2.vue?vue&type=script&lang=js&"
export * from "./serialPack2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49715010",
  null
  
)

export default component.exports